import { CampaignRating } from '../../model/campaign'
import { campaignBaseApi } from '../campaignBaseApi'
import { CampaignApiTags, GetAllISRRatingsParams } from '../models'
import { campaignProcedureUrl, SP_LUT_CALCULATE_ALL_ISR_RATINGS } from '../procedures'

const ratingsEndpoints = campaignBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllISRRatings: build.query<CampaignRating[], GetAllISRRatingsParams>({
      transformResponse(response) {
        return response.Data.map((item) => ({
          isr: item.ISR.trim(),
          isrName: item.ISRName.trim(),
          score: item.TotalRating || 0,
        }))
      },

      query({ campaignId }) {
        return {
          url: campaignProcedureUrl(SP_LUT_CALCULATE_ALL_ISR_RATINGS),
          method: 'POST',
          data: {
            'p.CampaignId': campaignId,
          },
        }
      },

      providesTags: (_result, _error, params) => [
        { type: CampaignApiTags.CampaignRatings, id: params.campaignId },
      ],
    }),
  }),
})

export const { useGetAllISRRatingsQuery } = ratingsEndpoints
